import { render, staticRenderFns } from "./table.rdb.vue?vue&type=template&id=ab97548a"
import script from "./table.rdb.vue?vue&type=script&lang=js"
export * from "./table.rdb.vue?vue&type=script&lang=js"
import style0 from "./table.rdb.vue?vue&type=style&index=0&id=ab97548a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports